<template>
  <div class="page-content commercial" :class="detailDialogVisible || inventoryDialogAction != '' ? 'overhide' : ''">
    <h1 class="page-title">{{ $locale("sideMenu.shop.commercial") }}</h1>

    <!-- Search Area -->
    <el-row :gutter="10" class="search-area">
      <el-col :span="14">
        <el-row :gutter="10">
          <el-col :span="10">
            <el-input
              :placeholder="$locale('form.plsEnterYourName')"
              v-model="filter.name"
              @keyup.enter.native="filter_fn"
            >
              <i slot="suffix" class="el-input__icon el-icon-search" @click="filter_fn"></i>
            </el-input>
          </el-col>
          <el-col :span="7">
            <el-select
              :placeholder="$locale('global.allDepartments')"
              v-model="filter.groupIds"
              multiple
            >
              <el-option
                v-for="item in departmentOption"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-button class="egl-btn-yellow" @click="filter_fn">{{$locale("global.search")}}</el-button>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="10" class="ta-r">
        <el-button class="egl-btn-gray" disabled v-if='getApproveItem().length === 0'>{{ $locale("global.approve") }}</el-button>
        <el-button class="egl-btn-yellow" @click="approve_fn" v-else>{{ $locale("global.approve") }}</el-button>
        <el-button class="egl-btn-yellow" @click="showDetailDailog">{{ $locale("global.create") }}</el-button>
      </el-col>
    </el-row>

    <el-row :gutter="10" class="search-area">
      <el-col :span="24" class="ta-r">
        <dlPDF uploadType="commercialMenuPdf" />
        <el-button class="egl-btn-yellow" @click="exportInventory_fn">{{ $locale("global.inventoryTable") }}</el-button>
        <UploadContainer
          :type="'C'"
          :imageList="[csvList]"
          :uploadBtnText="$locale('global.uploadInventoryTable')"
          :action="uploadInventoryUrl"
          :accept="'.csv'"
          @onSuccess="({response}) => uploadSuccess(response)"
        ></UploadContainer>
        <el-button class="egl-btn-yellow" @click="exportCSV_fn">{{ $locale("global.listCSV") }}</el-button>
        <UploadContainer
          :type="'C'"
          :imageList="[csvList]"
          :uploadBtnText="$locale('global.CSVBatchOperation')"
          :action="uploadCSVUrl"
          :accept="'.csv'"
          @onSuccess="({response}) => uploadSuccess(response)"
        ></UploadContainer>
      </el-col>
    </el-row>

    <el-table
      :data="tableData"
      class="egl-table list-table"
      ref="table"
      stripe
      @filter-change="getMsg"
      @sort-change="sortChange"
    >
      <el-table-column :label="$locale('global.change')" width="50" align="center">
        <template slot-scope="scope">
          <i class="el-icon-circle-check change" v-show="!scope.row.approve && !scope.row.reflect"></i>
        </template>
      </el-table-column>
      <el-table-column :label="$locale('global.image')" width="120" align="center">
        <template slot-scope="scope">
          <el-image style="width: 80px; height: 80px" :src="scope.row.imageUrl" fit="cover">
            <div slot="error" class="image-error-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('global.name')"
        prop="name"
        min-width="150"
        sortable
      ></el-table-column>
      <el-table-column
        :label="$locale('global.productCode')"
        prop="productCode"
        sortable
        min-width="120"
        column-key="productCode"
      ></el-table-column>
      <el-table-column
        column-key="groupName"
        :label="$locale('global.department')"
        prop="groupName"
        min-width="100"
      ></el-table-column>
      <!-- <el-table-column
        column-key="salesGroupName"
        :label="$locale('global.salesDepartment')"
        prop="salesGroupName"
        :filters="filterSalesGroupOptions"
        min-width="100"
      ></el-table-column> -->
      <el-table-column
        :label="$locale('bookKeeping.journal.dept')"
        min-width="160"
      >
        <template slot-scope="scope">
          {{ getTrandeGroupName(scope.row.journalType )}}
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('global.works')"
        prop="filmName"
      ></el-table-column>
      <el-table-column
        :label="$locale('global.unitPrice')"
        prop="price"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.price === "" ? "" : "¥ " + currencyFormat(scope.row.price) }}
        </template>
      </el-table-column>
      <el-table-column
        :label="$locale('shop.minStockQuantity')"
        prop="stockMin"
        align="center"
        min-width="85"
      ></el-table-column>
      <el-table-column prop="groupName" :label="$locale('form.displayPOS')" width="200"></el-table-column>
      <!-- <el-table-column prop="scGroupName" :label="$locale('form.displaySC')" width="240"></el-table-column> -->
      <el-table-column
        column-key="publish"
        :label="$locale('global.status')"
        prop="statusText"
        :filters="[
          {
            text: this.$locale('global.selling'),
            value: 'RELEASE'
          },
          {
            text: this.$locale('global.updating'),
            value: 'SALESUPDATE'
          },
          {
            text: this.$locale('global.stopSelling'),
            value: 'RESERVE'
          }
        ]"
        :filtered-value="['RELEASE', 'SALESUPDATE', 'RESERVE']"
        min-width="110"
        align="center"
      ></el-table-column>
      <el-table-column :label="$locale('global.control')" align="center" width="130">
        <template slot-scope="scope">
          <div class="handle" v-if="!scope.row.membershipId">
            <a @click="showInventoryDialog(scope.$index)" :class="!scope.row.useStock ? 'disabled' : ''">{{ $locale("global.inventoryChange") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="showDetail(scope.row.id, 'edit')">{{ $locale("global.edit") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="copyFunc(scope.row)">{{ $locale("shop.copy") }}</a>
            <el-divider direction="vertical"></el-divider>
            <a @click="delete_fn(scope.row.id)">{{ $locale("global.delete") }}</a>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <CommPagination
      :total="pageCount"
      :curPage="onSearch.page"
      :pageSize="onSearch.pageSize"
      @current-change="choosePage"
    />

    <CommercialDialog
      v-bind:action="action"
      v-bind:actionVisible="detailDialogVisible"
      v-bind:departmentOption="departmentOption"
      v-bind:salesGroupData="salesGroup"
      v-bind:couponTypeList="couponTypeList"
      v-bind:movieList="movieList"
      v-bind:detailObj="dailogDetailMsg"
      v-bind:clientList="clientList"
      @closeFn="closeDetailDailog"
      @returnMsg="getChildMsg"
      :brandSetting="brandSetting"
    ></CommercialDialog>

    <InventoryDialog
      v-bind:action="inventoryDialogAction"
      v-bind:tableList="inventoryDetailTable"
      @closeFn="closeInventoryDialog"
      @returnMsg="getInventoryDialogMsg"
    ></InventoryDialog>
  </div>
</template>

<script>
import tranfResData from "@/utils/tranfResData";
import CommercialDialog from "@/components/Commercial/Dialog.vue";
import InventoryDialog from "@/components/Commercial/InventoryDialog.vue";
import {
  getDepartment,
  getCommercialType,
  // getSalesGroup,
  createCommercialType,
  deleteCommercialType,
  updateCommercialType,
  updateInventory,
  approveCommercialType,
  inventoryExport,
  commercialTypeExport,
  conmmercialTypeDetail
} from "@/helpers/service/api/commercial.js";
import { getCouponTypeList, getCouponTypeListForSelect } from "@/helpers/service/api/coupon";
import { getSimpleMovieList, getClientListService } from "@/helpers/service/api/common.js";
import { getBrandDetail } from "@/helpers/service/api/brand.js";
import { requestAll } from "@/helpers/service/axiosPlugin";
import { priceFormat } from "@/utils/common";
import countDownAlert from "@/utils/countDownAlert";
import "@/assets/style/commercial.less";
import { getListService } from "@/helpers/service/api/tradeGroup";
import CommPagination from "@/components/common/CommPagination";
import UploadContainer from "@/components/common/UploadContainer";
import { decimal2 } from "@/utils/utils";
import dlPDF from "@/components/common/dlPDF";

export default {
  name: "Commercial",
  data() {
    return {
      action: "create",
      onSearch: {
        name: "",
        groupIds: [],
        sortType: "",
        sortKey: "",
        page: 0,
        pageSize: 10,
      },
      filter: {
        name: "",
        groupIds: [],
        page: 0,
        pageSize: 10
      },
      pageCount: 0,
      cinemaId: "",
      tableData: [],
      originalData: [],
      departmentOption: [],
      couponTypeList: [],
      salesGroup: [],
      filterGroupOptions: [],
      filterCouponOptions: [],
      filterSalesGroupOptions: [],
      filterStatusOptions: [],
      dailogDetailMsg: {},
      detailDialogVisible: false,
      ingredientList: [],
      inventoryDialogAction: "",
      inventoryDetailTable: [],
      setStockId: "",
      token: "",
      csvList: [],
      movieList: [],
      uploadCSVUrl_original: "/api/commercialType/import/add?cinemaId=",
      uploadCSVUrl: "/api/commercialType/import/add?cinemaId=",
      uploadInventoryUrl_original: "/api/commercialType/inventoryImport?cinemaId=",
      uploadInventoryUrl: "/api/commercialType/inventoryImport?cinemaId=",
      clientList: [],
      brandSetting: {},
      tradeGroupList:[],
    };
  },
  methods: {
    getTrandeGroupName(id) {
      let index = this.tradeGroupList.findIndex(x => x.id === id);
      if(index < 0) {
        return "";
      }
      return this.tradeGroupList[index].name;
    },
    currencyFormat(value, num) {
      return priceFormat(value, num);
    },
    filterChange(filterArray) {
      const { groupName, salesGroupName, publish } = filterArray;

      if (
        (groupName && groupName.length === 0) ||
        (salesGroupName && salesGroupName.length === 0) ||
        (publish && publish.length === 0)
      ) {
        this.$refs.table.clearFilter();
        this.tableData = this.originalData;
        return;
      }

      let filteredData = [];
      if (groupName && groupName.length > 0) {
        groupName.forEach(gid => {
          const matched = this.originalData.filter(list => list.groupId === gid);
          filteredData.push(...(matched ? matched : []));
        });

        this.$refs.table.clearFilter("salesGroupName");
        this.$refs.table.clearFilter("publish");
      }

      if (salesGroupName && salesGroupName.length > 0) {
        salesGroupName.forEach(gid => {
          const matched = this.originalData.filter(list => list.salesGroupId === gid);
          filteredData.push(...(matched ? matched : []));
        });

        this.$refs.table.clearFilter("groupName");
        this.$refs.table.clearFilter("publish");
      }

      if (publish && publish.length > 0) {
        publish.forEach(pub => {
          const matched = this.originalData.filter(list => list.publish === pub);
          filteredData.push(...(matched ? matched : []));
        });

        this.$refs.table.clearFilter("groupName");
        this.$refs.table.clearFilter("salesGroupName");
      }

      this.tableData = filteredData;
    },
    getDepartment_fn() {
      return getDepartment(
        {
          cinemaId: this.cinemaId,
          page: 0,
          pageSize: 9999,
          type: "commercial"
        },
        false,
        false
      );
    },
    search_fn(value) {
      let requestObj = {
        cinemaId: this.cinemaId,
        approve: false,
        ...value ? { publishTypeList: value } : {},
      };

      Object.keys(this.onSearch).forEach(_key => {
        if (this.onSearch[_key] !== "") {
          requestObj[_key] = this.onSearch[_key];
        }
      });

      return getCommercialType(requestObj, false, false);
    },
    // getSalesGroup_fn() {
    //   return getSalesGroup(
    //     { cinemaId: this.cinemaId, page: 0, pageSize: 9999 },
    //     false,
    //     false
    //   );
    // },
    getMovieList_fn() {
      return getSimpleMovieList(
        { cinemaId: this.cinemaId, page: 0, pageSize: 9999, approve: true, field: ['id', 'name'], hiddenCms: false },
        false,
        false
      );
    },
    getCouponList_fn() {
      let obj = { page: 0, pageSize: 9999, cinemaId: this.cinemaId };
      return getCouponTypeList(obj, false, false);
    },
    getBrandDetail_fn() {
      const brandId = window.localStorage.getItem("brandId");

      if (brandId) {
        return getBrandDetail({ id: brandId });
      }
    },
    getMsg(value) {
      const that = this;
      let cinemaId = window.localStorage.getItem("cinemaId") || "";

      if (cinemaId == "") {
        this.$emit("callCinema", "getMsg");

        // return;
      } else {
        this.cinemaId = cinemaId;
        this.uploadCSVUrl = this.uploadCSVUrl_original + cinemaId;
        this.uploadInventoryUrl = this.uploadInventoryUrl_original + cinemaId;
      }
      this.cinemaId = cinemaId;

      if (!cinemaId) { return; }

      requestAll([
        that.search_fn(value ? value.publish : null),
        that.getDepartment_fn(),
        // that.getSalesGroup_fn(),
        that.getMovieList_fn(),
        // that.getCouponList_fn(),
        // this.getBrandDetail_fn(),
      ])
        .then(res => {
          const _commercialList = res[0].data ? res[0].data.data || [] : [];
          const _departmentList = [{ id: '', name: this.$locale('global.none')}, ...(
            res[1].data && res[1].data.length > 0 ? res[1].data : []
          )]
          const _movieList = res[2].data ? res[2].data.data || [] : [];
          // const _couponList = res[3].data ? res[3].data.data || [] : [];
          // const _brandDetailData = res[3].data || {};

          let formatData = that.formatData(
            _commercialList,
            _departmentList,
            _movieList,
          );

          // if (that.$refs.table && !type) {
          //   that.$refs.table.clearSort();
          //   this.$refs.table.clearFilter();
          // }

          that.departmentOption = _departmentList;
          // that.salesGroup = res[2].data.data;
          that.tableData = formatData.tableData;
          that.originalData = formatData.tableData;
          // that.pageCount = Math.ceil(res[0].data.count / that.onSearch.pageSize);
          that.pageCount = res[0].data ? res[0].data.count || 0 : 0;
          that.movieList = _movieList;
          // that.couponTypeList = _couponList;

          that.movieList.unshift({
            id: null,
            name: this.$locale("global.none"),
          });

          this.filterGroupOptions = [];
          this.departmentOption.forEach(group => {
            this.filterGroupOptions.push({
              text: group.name,
              value: group.id,
            });
          });
          /*this.filterCouponOptions = [];
          this.couponTypeList.forEach(coupon => {
            this.filterCouponOptions.push({
              text: coupon.name,
              value: coupon.id,
            });
          });*/

          this.filterSalesGroupOptions = [];
          this.salesGroup.forEach(group => {
            this.filterSalesGroupOptions.push({
              text: group.name,
              value: group.id,
            });
          });

          // const brandDetailData = tranfResData(_brandDetailData);
          // this.brandSetting = brandDetailData.brandSetting;
        });
    },
    formatData(data, department, filmList) {
      const statusArr = [
        {
          type: "RELEASE",
          text: this.$locale("global.sale"),
        },
        {
          type: "RESERVE",
          text: this.$locale("global.stopSelling"),
        }
      ];
      let tableData = [];
      let checkbox = {
        statusText: []
      };

      data.map(obj => {
        obj.groupName = "";
        obj.filmName = "";
        obj.statusText = "";
        // obj.salesGroupId = obj.salesGroup.id;
        // obj.salesGroupName = obj.salesGroup.name;
        obj.salesGroupId = obj.salesGroup ? obj.salesGroup.id : "";
        obj.salesGroupName = obj.salesGroup ? obj.salesGroup.name : "";

        for (let i = 0; i < department.length; i++) {
          if (obj.groupId == department[i].id) {
            obj.groupName = department[i].name;
            break;
          }
        }

        for (let i = 0; i < filmList.length; i++) {
          if (filmList[i].id == obj.filmId) {
            obj.filmName = filmList[i].name;
            break;
          }
        }

        for (let i = 0; i < statusArr.length; i++) {
          if (obj.publish == statusArr[i].type) {
            obj.statusText = statusArr[i].text;
            break;
          }
        }

        if (
          obj.statusText != "" &&
          checkbox.statusText.indexOf(obj.statusText) < 0
        ) {
          checkbox.statusText.push(obj.statusText);
        }

        tableData.push({ ...obj });
      });

      return { tableData, checkbox };
    },
    choosePage(page) {
      this.onSearch = {
        ...this.onSearch,
        page: page - 1
      };

      this.getMsg();
    },
    filter_fn() {
      this.onSearch = { ...this.onSearch, ...this.filter };

      this.getMsg();
    },
    showDetailDailog() {
      if (this.couponTypeList.length === 0) {
        getCouponTypeListForSelect({
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 20,
          field: ["id", "name"]
        }).then(res => {
          if (res.data && res.data.data) this.couponTypeList = res.data.data;
        });
      }
      this.dailogDetailMsg = {};
      this.action = "create";
      this.detailDialogVisible = true;
      
    },
    closeDetailDailog() {
      this.detailDialogVisible = false;
      this.action = "";
    },
    getChildMsg(obj) {
      const that = this;

      if (obj.id) {
        updateCommercialType({
          commercialTypeInfo: { ...obj, cinemaId: that.cinemaId }
        })
          .then(res => {
            if (res.success) {
              that.countDown(that.$locale("global.updateSuccessfully"));
              that.detailDialogVisible = false;
              that.getMsg();
            }
          });
      } else {
        createCommercialType({
          commercialTypeInfo: { ...obj, cinemaId: that.cinemaId }
        })
          .then(res => {
            if (res.success) {
              that.countDown(that.$locale("global.createSuccessfully"));
              that.detailDialogVisible = false;
              that.getMsg();
            }
          });
      }
      that.action = "";
    },
    // tableHeaderFilter() {
    //   let filter = { ...this.theadCheckboxVal };
    //   let data = this.filterData(this.originalData, filter);

    //   this.tableData = data;
    //   this.$refs.table.clearSort();
    // },
    // filterData: (data, filter) => {
    //   let arr = [];
    //   let filterKeyName = Object.keys(filter);

    //   data.map(obj => {
    //     let isPush = true;

    //     for (let i = 0; i < filterKeyName.length; i++) {
    //       let keyName = filterKeyName[i];

    //       if (filter[keyName].indexOf(obj[keyName]) < 0) {
    //         isPush = false;
    //         break;
    //       }
    //     }

    //     if (isPush) {
    //       arr.push({ ...obj });
    //     }
    //   });

    //   return arr;
    // },
    delete_fn(id) {
      const that = this;
      let name = "";
      let confirmHtml = "";

      for (let i = 0; i < this.tableData.length; i++) {
        const { id: dataId, name: dataName } = this.tableData[i];

        if (id == dataId) {
          name = dataName;
          confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.delete")} ${name}</span>`;

          break;
        }
      }

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.delete"),
        customClass: "egl-confirm",
        closeOnClickModal: false
      })
        .then(() => {
          // confirm
          deleteCommercialType({ id: id })
            .then(res => {
              if (res.success) {
                that.countDown(this.$locale("global.deleteSuccessfully"));
                that.getMsg();
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    // detail_fn(id) {
    //   for (let i = 0; i < this.tableData.length; i++) {
    //     if (id == this.tableData[i].id) {
    //       this.dailogDetailMsg = { ...this.tableData[i] };

    //       break;
    //     }
    //   }

    //   this.action = "detail";
    //   this.detailDialogVisible = true;
    // },
    // edit_fn(id) {
    //   for (let i = 0; i < this.tableData.length; i++) {
    //     if (id == this.tableData[i].id) {
    //       this.dailogDetailMsg = { ...this.tableData[i] };

    //       break;
    //     }
    //   }

    //   this.action = "edit";
    //   this.detailDialogVisible = true;
    // },
    showDetail(id, type) {
      requestAll([
        conmmercialTypeDetail({ id }),
        this.couponTypeList.length === 0 ? getCouponTypeListForSelect({
          cinemaId: window.localStorage.getItem("cinemaId"),
          page: 0,
          pageSize: 20,
          field: ["id", "name"]
        }) : null
      ]).then(res => {
        this.dailogDetailMsg = res[0].data;
        if (res[1] && res[1].data && res[1].data.data) this.couponTypeList = res[1].data.data;
        this.action = type;
        this.detailDialogVisible = true;
      })
    },
    showInventoryDialog(index) {
      let tableList = [];

      this.tableData[index].options.map(optionObj => {
        tableList.push({
          id: optionObj.uuid,
          name: optionObj.name,
          num: optionObj.inventory,
          unit: this.tableData[index].unit
        });
      });
      this.inventoryDetailTable = tableList;
      this.setStockId = this.tableData[index].id;
      this.inventoryDialogAction = "show";
    },
    closeInventoryDialog() {
      this.inventoryDetailTable = [];
      this.setStockId = "";
      this.inventoryDialogAction = "";
    },
    getInventoryDialogMsg(obj) {
      let queryString = `id=${this.setStockId}&inventoryChangeQty=${obj.inventoryChangeQty}&inventoryChangeSupplement=${obj.inventoryChangeSupplement}&inventoryChangeType=${obj.inventoryChangeType}&actualDate=${obj.processingDate}&inventoryType=commercial`;

      if (obj.id != "") {
        queryString = queryString + "&optionId=" + obj.id;
      }

      updateInventory(queryString).then(res => {
        if (res.success) {
          this.countDown(this.$locale("global.updateSuccessfully"));
          this.closeInventoryDialog();
          this.getMsg();
        }
      }).catch(() => {});
    },
    countDown(str = this.$locale("global.createSuccessfully")) {
      countDownAlert({ content: str });
    },
    showApprove() {
      this.$refs.approve.toggleApprove();
    },
    approve_fn() {
      const that = this;
      let confirmHtml = `<i class="egl-confirm-question">?</i><span class="result-text">${this.$locale("global.approveAll")}</span>`;

      this.$confirm(confirmHtml, "", {
        dangerouslyUseHTMLString: true,
        showClose: false,
        showCancelButton: true,
        cancelButtonClass: "egl-btn-white",
        cancelButtonText: this.$locale("global.cancel"),
        showConfirmButton: true,
        confirmButtonClass: "egl-btn-yellow",
        confirmButtonText: this.$locale("global.approve"),
        customClass: "egl-confirm",
        closeOnClickModal: false,
      })
        .then(() => {
          approveCommercialType({
            cinemaId: that.cinemaId,
          }).then(() => {
            that.getMsg();
          });
        });
    },
    getApproveItem() {
      let approveArr = [];
      let { tableData } = this;
      for (let i = 0; i < tableData.length; i++) {
        if (!tableData[i].approve && !tableData[i].reflect) {
          approveArr.push(tableData[i].id);
        }
      }
      return approveArr;
    },
    exportInventory_fn() {
      inventoryExport({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
      }).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = `${this.$locale("global.inventoryTable")}.csv`;
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    uploadSuccess(res) {
      if (res.success) {
        this.getMsg();
      }
      this.csvList = [];
    },
    exportCSV_fn() {
      commercialTypeExport({
        cinemaId: this.cinemaId,
        page: 0,
        pageSize: 9999,
        name: this.filter.name,
        groupIds: this.filter.groupIds,
      }).then(res => {
        const bom = new Uint8Array([0xEF, 0xBB, 0xBF]); // UTF-8 BOM
        const content = new TextEncoder().encode(res);
        const blob = new Blob([ bom, content ], { type: 'text/csv;charset=utf-8;' });
        const blobUrl = window.URL.createObjectURL(blob);
        const aElement = document.createElement("a");
        aElement.href = blobUrl;
        aElement.download = `${this.$locale("global.productSalesList")}.csv`;
        aElement.click();
        window.URL.revokeObjectURL(blobUrl);
      });
    },
    sortChange(val) {
      this.$refs.table.clearFilter();
      this.onSearch.sortType = val.order === "descending" ? "DESC" : (val.order === "ascending" ? "ASC" : val.order);
      this.onSearch.sortKey = val.order === null ? "" : val.prop;
      this.getMsg();
    },
    copyFunc(row) {
      const obj = this.$_.omit(row, ['id'])
      createCommercialType({
          commercialTypeInfo: { ...obj, name: `${obj.name}＿複製`, cinemaId: this.cinemaId }
        })
          .then(res => {
            if (res.success) {
              this.countDown(this.$locale("global.createSuccessfully"));
              this.onSearch.page = 0;
              this.getMsg();
            }
          });
    }
  },
  created() {
    getClientListService({
      page: 0,
      pageSize: 20,
      field: ["id", "name"]
    }).then(res => {
      if (res.data && res.data.data) this.clientList = res.data.data;
    });
    // getCouponTypeListForSelect({
    //   cinemaId: window.localStorage.getItem("cinemaId"),
    //   page: 0,
    //   pageSize: 20,
    //   field: ["id", "name"]
    // }).then(res => {
    //   if (res.data && res.data.data) this.couponTypeList = res.data.data;
    // });
  },
  mounted() {
    let cinemaId = window.localStorage.getItem("cinemaId") || "";
    const token = window.localStorage.getItem("token");

    this.cinemaId = cinemaId;
    this.uploadCSVUrl = this.uploadCSVUrl_original + cinemaId;
    this.uploadInventoryUrl = this.uploadInventoryUrl_original + cinemaId;
    this.token = token;
    // getClientListService({
    //   page: 0,
    //   pageSize: 9999,
    //   field: ["id", "name", "clientCode", "groupName", "aliasName"]
    // }).then(res => {
    //   this.clientList = res.data.data;
    // });
    // getListService({
    //   brandId: window.localStorage.getItem("brandId")
    // }).then(res => {
    //   this.tradeGroupList = res.data;
    // }).catch(err => {
    //   console.log(err);
    // });
    this.getMsg();
  },
  components: {
    CommercialDialog,
    InventoryDialog,
    CommPagination,
    UploadContainer,
    dlPDF
  }
};
</script>
